var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout_body", attrs: { id: "layout_body" } },
    [
      _c("canvas", {
        ref: "headCanvas",
        staticStyle: {
          position: "absolute",
          height: "0",
          width: "0",
          opacity: "0",
        },
      }),
      _c("div", { staticClass: "bg-wrapper", style: _vm.getPageStyle }),
      _c(
        "div",
        { staticClass: "layer-wrapper" },
        [
          _vm._l(_vm.widgets, function (item, i) {
            return [
              !item.hidden && _vm.$store.state.widgets.PendantObj[item.cmpType]
                ? _c("basic_module", {
                    key: item.tid,
                    attrs: { module: item, index: i, type: _vm.type },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }